import { ref, watch } from 'vue';
import { Tabs, TabPane } from 'ant-design-vue';
export default {
  name: 'XTabBar',
  components: {
    ATabs: Tabs,
    ATabPane: TabPane
  },
  props: {
    activeKey: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    },
    leftExtra: {
      type: [String, Function],
      default: undefined
    },
    rightExtra: {
      type: [String, Function],
      default: undefined
    }
  },
  emits: ['changed', 'close-tab'],
  setup(props, context) {
    const activeKeyRef = ref(props.activeKey);
    watch(() => props.activeKey, val => {
      if (val !== activeKeyRef.value) {
        activeKeyRef.value = val;
      }
    });
    context.expose({
      setActiveKey: key => {
        if (key !== activeKeyRef.value) {
          activeKeyRef.value = key;
        }
      },
      currentKey: () => activeKeyRef.value
    });
    const handleTabEdit = (key, action) => {
      if (action === 'remove') {
        context.emit('close-tab', key);
      }
    };
    const handleTabChanged = key => {
      context.emit('changed', key);
    };
    return {
      activeKeyRef,
      handleTabEdit,
      handleTabChanged
    };
  }
};